import { LottieOptions, useLottie } from 'lottie-react';

export const useSVGAnimation = (
  animation: object,
  config: Omit<LottieOptions, 'animationData'> = {}
) => {
  const options = {
    animationData: animation,
    loop: true,
    autoplay: true,
    ...config,
  };

  return useLottie(options);
};
